import {
  ConversationSummaries, ConversationType,
} from '@marageti/z4-sdk/lib/travel';
import React from 'react';
import { OutlinedIcons } from '@marageti/z4-lib';

const getConversationSummaryByConversationId = (conversationId: string, conversationSummaries: ConversationSummaries) => conversationSummaries && conversationSummaries.find(
  (summary) => summary.conversationId === conversationId,
);

const getConversationSummaryByConversationType = (conversationType: ConversationType, conversationSummaries: ConversationSummaries) => conversationSummaries && conversationSummaries.find(
  (summary) => summary.conversationType === conversationType,
);

const getConversationIcon = ({
  conversationType,
}: {
  conversationType: ConversationType
}) => {
  switch (conversationType) {
    case ConversationType.TravelerToPartner:
      return <OutlinedIcons.OutlinedBriefcaseIcon />;
    case ConversationType.ZicassoToPartner:
      return <OutlinedIcons.OutlinedOfficeBuildingIcon />;
    case ConversationType.TravelerToZicasso:
      return <OutlinedIcons.OutlinedHeartIcon />;
    default:
      return <OutlinedIcons.OutlinedHeartIcon />;
  }
};

const getConversationTypeTitle = ({
  conversationType,
}: {
  conversationType: ConversationType
}) => {
  switch (conversationType) {
    case ConversationType.TravelerToPartner:
      return 'Traveler';
    case ConversationType.ZicassoToPartner:
      return 'Partner';
    case ConversationType.TravelerToZicasso:
      return 'Zicasso Care';
    default:
      return 'Unknown Conversation Type';
  }
};

export {
  getConversationSummaryByConversationId,
  getConversationSummaryByConversationType,
  getConversationIcon,
  getConversationTypeTitle,
};
